// plant control center
import React from "react";

export default function PlantHUD({ onOpenLeaves, onCloseLeaves }) {
  return (
    <div className="leaf-btn">
      <button className="leaf-control-btn open" onClick={onOpenLeaves}>
        Abrir Flohas
      </button>

      <button className="leaf-control-btn close" onClick={onCloseLeaves}>
        Fechar Folhas
      </button>
    </div>
  );
}